import { Skeleton } from '@backyard-ui/core';

function PageIndicator() {
  return (
    <Skeleton
      data-testid="page-indicator-skeleton"
      width="112px"
      height="16px"
    />
  );
}
export default PageIndicator;
